import { useEffect, useState, useRef } from "react";
import { Empty, Spin, Flex, Button, Upload, Row, Col, Dropdown } from "antd";

import PlusIcon from "@/icons/PlusIcon";

import FilesTable from "@/components/tables/FilesTable";
import FileCard from "@/components/cards/FileCard";

const FilesTab = ({
  data,
  pending,
  unit_uuid,
  handleAddNew,
  handleEditFile,
  handleDeleteFile,
  handleAddFileLink,
  readOnly,
  uploadsProps,
}) => {
  const [selectView, setSelectView] = useState("table");

  const uploadHiddenBtnRef = useRef(null);

  const addFileMenu = {
    items: [
      { key: "device", label: "Добавить файл с устройства" },
      { key: "system", label: "Добавить файл из системы" },
    ],
    onClick: ({ key }) => {
      if (key === "device") {
        uploadHiddenBtnRef.current?.click();
      } else if (key === "system") {
        handleAddFileLink();
      }
    },
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setSelectView("cards");
      } else {
        setSelectView("table");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const renderContent = () => {
    if (pending) {
      return (
        <div className="spin" style={{ height: 100 }}>
          <Spin size="large" />
        </div>
      );
    }

    if (!data.length) {
      return (
        <>
          <Flex justify="flex-end" gap={15} align="center">
            {!readOnly && (
              <Dropdown menu={addFileMenu} trigger={["click"]}>
                <Button type="primary" icon={<PlusIcon />} />
              </Dropdown>
            )}
          </Flex>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </>
      );
    }

    return (
      <Flex vertical gap={15}>
        <Flex justify="flex-end" gap={15} align="center">
          {!readOnly && (
            <Dropdown menu={addFileMenu} trigger={["click"]}>
              <Button type="primary" icon={<PlusIcon />} />
            </Dropdown>
          )}
        </Flex>

        {selectView === "table" ? (
          <FilesTable
            pagination={false}
            unit_uuid={unit_uuid}
            data={data}
            show_unit={false}
            show_description
            loading={pending}
            onEditItem={handleEditFile}
            onDeleteItem={handleDeleteFile}
            readOnly={readOnly}
          />
        ) : (
          <Row gutter={[16, 16]}>
            {data.map((file) => (
              <Col xs={24} key={file.uuid}>
                <FileCard
                  file={file}
                  onEdit={handleEditFile}
                  onDelete={handleDeleteFile}
                  readOnly={readOnly}
                />
              </Col>
            ))}
          </Row>
        )}
      </Flex>
    );
  };

  return (
    <>
      {renderContent()}

      <Upload {...uploadsProps} onChange={handleAddNew} style={{ display: "none" }}>
        <Button ref={uploadHiddenBtnRef} style={{ display: "none" }} />
      </Upload>
    </>
  );
};

export default FilesTab;
